<template>
  <v-dialog width="600" v-model="dialog" @click:outside="closeDialog()">
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" style="width :100%">
          <h3>Thiết lập phân công quản lý kho</h3>
          <div class="close-btn" @click="() => closeDialog()">
            <v-icon>
              mdi-close
            </v-icon>
          </div>
        </div>
      </v-card-title>
      <v-divider class="mb-4 mt-2" />
      <v-card-text>
        <v-select
          label="Kho"
          placeholder="Chọn kho"
          item-text="name"
          item-value="id"
          :items="inventories"
          v-model="inventory"
          :rules="[$rules.required]"
          dense
          :disabled="type === 'add'"
          class="mt-2"
          outlined
        ></v-select>
        <v-autocomplete
          v-model="selectedUsers"
          :items="users"
          outlined
          dense
          chips
          small-chips
          item-text="name"
          item-value="id"
          label="Người dùng"
          placeholder="Chọn người dùng"
          multiple
        ></v-autocomplete>
      </v-card-text>
      <v-divider class="mb-2" />
      <v-card-actions>
        <v-btn class="mb-2" color="primary" outlined @click="() => closeDialog()">Huỷ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="onSave">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  computed: mapState({
    users(state) {
      return state['inventoryManagement'].users
    },
    item(state) {
      return state['inventoryManagement'].itemToEdit
    },
    inventories(state) {
      return state['inventories'].items
    }
  }),
  data() {
    return {
      dialog: false,
      loading: false,
      get,
      selectedUsers: [],
      type: 'add',
      inventory: null
    }
  },
  methods: {
    ...mapActions({
      fetchUsers: 'inventoryManagement/fetchUsers',
      fetchInventories: 'inventories/fetchItems',
      update: 'inventoryManagement/updateItem'
    }),
    closeDialog() {
      this.dialog = false
    },
    onClear() {
      this.user = []
    },
    async openDialog(type) {
      this.dialog = true
      this.loading = true
      this.type = type
      try {
        await this.fetchUsers()
        await this.fetchInventories()
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra trong quá trình tải dữ liệu người dùng')
      }
    },
    async onSave() {
      try {
        await this.update({ id: this.inventory, userIds: this.selectedUsers })
        this.$emit('onRefresh')
        this.$alert.success('Cập nhập thành công')
        this.dialog = false
      } catch (error) {
        this.dialog = false
        this.$alert.error('Có lỗi xảy ra trong quá trình cập nhập')
      }
    }
  },
  watch: {
    item: {
      handler(val) {
        if (val && val.id) {
          this.inventory = val.id
          this.selectedUsers = val.users
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.close-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }
}
</style>
